import { useState } from 'react';

interface UsePaginationProps {
  initialPage?: number;
  initialPageSize?: number;
  totalItems: number;
  onPageChange: (page: number, pageSize: number) => void;
}

export const usePagination = ({
  initialPage = 1,
  initialPageSize = 20,
  totalItems,
  onPageChange,
}: UsePaginationProps) => {
  const initialParametersPage = {
    current: initialPage,
    size: initialPageSize,
  };
  const [pagination, setPagination] = useState(initialParametersPage);

  const resetPagination = () => {
    setPagination({
      current: initialPage,
      size: initialPageSize,
    });
  };

  const setCurrentPage = (page: number) => {
    setPagination(prev => ({ ...prev, current: page }));
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= Math.ceil(totalItems / pagination.size)) {
      setPagination(prev => ({ ...prev, current: page }));
      onPageChange(page, pagination.size);
      window.scrollTo(0, 0);
    }
  };

  return {
    currentPage: pagination.current,
    pageSize: pagination.size,
    handlePageChange,
    resetPagination,
    setCurrentPage,
  };
};
